'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './vendor-list.routes';

export class VendorListComponent {
  constructor(Auth, VendorService, SettingsService, dialogs, $localStorage, DTOptionsBuilder, DTState, $timeout) {
    'ngInject';

    this.VendorService = VendorService;
    this.data = [];
    this.$timeout = $timeout;

    this.filteredData = [];
    this.asTable = !!$localStorage.vendorListAsTable;

    this.dialogs = dialogs;
    this.$localStorage = $localStorage;

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'asc'])
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save())
      .withOption('stateLoadCallback', DTState.restore())
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: "Vendors"
      },{
        extend: 'csv',
        title: "Vendors"
      },{
        title: "Vendors",
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },{
        extend: 'print',
        title: "Vendors"
      }]);

    SettingsService.getByName({name: 'config.app'}, appSettings => {
      this.categories = appSettings.data.businessTypes;
    });

    this.VendorService.query((data) => {
      this.data = data;
      this.filteredData = data;
      this.dataInitComplete = true;

      /*if (this.$localStorage.vendorCatFilter) {
        this.$timeout(_=> {
          console.log(this.$localStorage.vendorCatFilter);
          this.setFilter(this.$localStorage.vendorCatFilter);
        },0);
      }*/

    }, err => {
      console.log("Could not retrieve vendors.")
    });
  }


  getCount(cat) {
    return this.data.reduce((acc, obj) => {
      return acc + (obj.type === cat);
    }, 0);
  }

  setFilter(cat) {
    console.log("setFilter", cat);
    if (cat == '') {
      this.filteredData = this.data;
      //this.$localStorage.vendorCatFilter = undefined;
    } else {
      this.filteredData = this.data.filter(item => item.type == cat);
      //this.$localStorage.vendorCatFilter = cat;
    }

    /* Table */
    jQuery("table.dataTable").DataTable().columns(1).search(cat).draw();
  }

  setAsTable(val) {
    this.asTable = val;
    this.$localStorage.vendorListAsTable = val;
  }


  getPrimaryEmail(owner) {
    if (!owner || !owner.email || !owner.email.length)
      return "-";

    let email = owner.email.find(email => email.isPrimary) || owner.email[0] || {address:'-'};

    return email.address;
  }

  getPrimaryPhone(owner) {
    if (!owner || !owner.phone || !owner.phone.length)
      return "-";

    let phone = owner.phone.find(phone => phone.isPrimary) || owner.phone[0] || {number:'-'};

    return phone.number;
  }

  getPrimaryAddress(owner) {
    if (!owner || !owner.address || !owner.address.length)
      return "-";

    let address = owner.address.find(adr => adr.isPrimary) || owner.address[0] || {};

    return address.street + "<br/>" + address.city + ' ' + address.state + ', ' + address.zip;
  }

  delete(vendor) {
    var that = this;

    var vendorText = "<br/><br/><b>" + vendor.name + "</b><br/><p>" + vendor.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Vendor?", "Do you really want to delete this vendor?" + vendorText);
    dlg.result.then(() => {
      // OK delete it
      that.VendorService.delete({id: vendor._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== vendor._id;
          });
        },
        err => {
          alert("Could not delete vendor");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.vendorList', [uiRouter])
  .config(routes)
  .component('vendorList', {
    template: require('./vendor-list.html'),
    controller: VendorListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/vendor-list/vendor-list.component.js